export default (c) => {
    const style = getComputedStyle(document.documentElement)
    return style && style.getPropertyValue('--'+c) || 'rgb(0,44,66)'
}